"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskDateTimePicker = void 0;
var _react = require("react");
var _DateTimePickers = require("../../../../../../../UI/DateTimePickers");
var _useItem = require("../../../../../hooks/useItem");
var _TaskManager = require("../../../../../TaskManager.provider");
var _SectionLabel = require("../../../SectionLabel");
var _TaskDateTimePicker = _interopRequireDefault(require("./TaskDateTimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TaskDateTimePicker = props => {
  const {
    minDate = new Date(),
    maxDate,
    itemID,
    taskID,
    itemLanguage,
    kotarParams,
    environmentID,
    audienceID,
    isChangeAudienceAfterSubmitEnabled,
    isLearningActivity
  } = props;
  const {
    task,
    setTask,
    setIsChanged,
    setShowReadOnlyMessageTiming,
    showReadOnlyMessageTiming,
    unitData,
    getLabel
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  const {
    getTaskTiming
  } = (0, _useItem.useItem)(itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity);
  const styles = (0, _TaskDateTimePicker.default)();
  const isTimeEnable = task?.taskType === 'exam';
  const toDay = (0, _react.useRef)(new Date());
  const dpMinDate = new Date(Math.max(minDate.getTime(), toDay.current.getTime()));
  const dpMaxDate = maxDate || unitData?.schoolYear.endDate;
  const handleStartDateChange = (newStart, newEnd) => {
    const {
      startDateTime,
      endDateTime,
      publishDate,
      feedbackDate
    } = getTaskTiming(task.taskType, newStart, task?.endDateTime);
    setTask({
      ...task,
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      publishDate: publishDate,
      feedbackDate: feedbackDate
    });
    setIsChanged(true);
  };
  const handleEndDateChange = (newStart, newEnd) => {
    const {
      endDateTime,
      publishDate,
      feedbackDate
    } = getTaskTiming(task.taskType, newStart, newEnd);
    setTask({
      ...task,
      endDateTime: endDateTime,
      publishDate: publishDate,
      feedbackDate: feedbackDate
    });
    setIsChanged(true);
  };
  const handleDisabledDateClick = () => {
    if (task && (task.isReadOnly || task.cannotModifyMembers && task.IsScheduled)) {
      setShowReadOnlyMessageTiming(getLabel(task.taskType === 'exam' ? 'message_start_datetime_disabled' : 'message_start_date_disabled'));
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__task-date-time-picker'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
      text: getLabel('text_label_when') + ' ',
      isDisabled: task?.isReadOnly,
      message: showReadOnlyMessageTiming
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-TaskManager__task-date-time-picker__frame'],
      children: isTimeEnable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.RangeDateTimePicker, {
          isDisabled: task && (task.isReadOnly || task.cannotModifyMembers && task.IsScheduled),
          startDateTime: task?.startDateTime,
          endDateTime: task?.endDateTime,
          minDateTime: dpMinDate,
          maxDateTime: dpMaxDate,
          anchorSubTextStartDate: getLabel('text_label_startDate'),
          anchorSubTextStartTime: getLabel('text_label_startTime'),
          startTimeTitle: getLabel('text_label_startTime'),
          btnProps: {
            view: 'text',
            onDisabledClick: handleDisabledDateClick
          },
          onChange: handleStartDateChange,
          attachedTo: "StartDate",
          minutesStep: 5,
          deltaHours: 2
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-TaskManager__task-date-time-picker__frame-spacer']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.RangeDateTimePicker, {
          isDisabled: task?.isReadOnly,
          startDateTime: task?.startDateTime,
          endDateTime: task?.endDateTime,
          minDateTime: task?.startDateTime || dpMinDate,
          maxDateTime: dpMaxDate,
          anchorSubTextEndDate: getLabel('text_label_submissionDate'),
          anchorSubTextEndTime: getLabel('text_label_submissionTime'),
          endTimeTitle: getLabel('text_label_submissionTime'),
          btnProps: {
            view: 'text'
          },
          onChange: handleEndDateChange,
          attachedTo: "EndDate",
          minutesStep: 5,
          deltaHours: 2
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.RangeDatePicker, {
          view: "menu",
          isDisabled: task && (task.isReadOnly || task.cannotModifyMembers && task.IsScheduled),
          startDate: task?.startDateTime,
          endDate: task?.endDateTime,
          minDate: dpMinDate,
          maxDate: dpMaxDate,
          anchorSubTextStart: getLabel('text_label_startDate'),
          btnProps: {
            view: 'text',
            onDisabledClick: handleDisabledDateClick
          },
          onChange: handleStartDateChange,
          attachedTo: "StartDate"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: styles['cc-TaskManager__task-date-time-picker__frame-spacer']
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateTimePickers.RangeDatePicker, {
          view: "menu",
          startDate: task?.startDateTime,
          endDate: task?.endDateTime,
          minDate: task?.startDateTime || dpMinDate,
          maxDate: dpMaxDate,
          anchorSubTextEnd: getLabel('text_label_submissionDate'),
          btnProps: {
            view: 'text'
          },
          onChange: handleEndDateChange,
          attachedTo: "EndDate"
        })]
      })
    })]
  });
};
exports.TaskDateTimePicker = TaskDateTimePicker;